import React, { useState, useEffect } from 'react'
import { Row } from 'antd'
import { useFormik } from 'formik'
import CreateScreen from '../../components/CreateScreen'
import CustomInput from '../../components/CustomInput/customInput'
import queryString from 'query-string'
import { api, request } from '../../util/handlerRequestUtil'
import './createBrand.css'
import * as yup from 'yup'

function CreateBrand(props) {
  const { id } = props.match.params
  const { alert, loading, getMessage } = props
  const isDuplicate = queryString.parse(window.location.search, {
    ignoreQueryPrefix: true
  }).duplicate
  const formik = useFormik({
    initialValues: {},
    validationSchema: yup.object().shape({
      name: yup
        .string()
        .typeError()
        .required(getMessage('isRequired', getMessage('name')))
    }),
    onSubmit: values => {
      let formatedValues = { ...values }
      onSubmit(formatedValues)
    }
  })
  const { setValues } = formik
  const [setFilters] = useState({})

  useEffect(() => {
    requests()
  }, [])

  //requests
  async function requests() {
    try {
      loading.open()
      if (id) {
        await retrieve(id)
      }
      if (isDuplicate) {
        await retrieve(isDuplicate, true)
      }
      setFilters({})
    } catch (error) {
      console.tron.log(error)
    } finally {
      loading.close()
    }
  }

  function fields(isReadOnly) {
    return (
      <Row type="flex" justify="start">
        <CustomInput disabled={isReadOnly} field="name" rowSpan={12} context={formik} />
      </Row>
    )
  }

  function onClickBack() {
    props.history.push('/Brand/list')
  }

  async function onSubmit(values) {
    try {
      if (id) {
        await request(api.updateBrand(id, values))
        alert.open(getMessage('successUpdateBrand'), 'success')
      } else {
        await request(api.storeBrand(values))
        alert.open(getMessage('successStoreBrand'), 'success')
      }

      props.history.push(`/Brand/list`)
    } catch (error) {}
  }

  async function retrieve(id, isDuplicate) {
    try {
      const response = await request(api.retrieveBrand(id), true)
      if (isDuplicate) {
        delete response.id
      }
      setValues({
        ...response
      })
    } catch (error) {}
  }

  return (
    <CreateScreen
      fields={fields}
      context={formik}
      editTitle={getMessage('updateBrand')}
      editTitleButton={getMessage('edit')}
      newTitle={getMessage('newBrand')}
      newTitleButton={getMessage('register')}
      readOnlyTitle={getMessage('viewBrand')}
      readOnlyTitleButton={getMessage('edit')}
      onClickBack={() => onClickBack()}
      isEdit={id}
    />
  )
}

export default CreateBrand
